/* ============================================================
   les Enfants Sauvages — Sync du compteur panier (v1 — 2026-06-09)
   Corrige le <cart-count> de l'en-tete (« Panier (X) » desktop + pastille
   mobile) qui restait fige lorsqu'une app (Monster Cart Upsell, etc.)
   ajoute au panier sans declencher la mise a jour du theme.
   Methode agnostique : on intercepte toute requete de modification du
   panier (fetch + XMLHttpRequest) et on resynchronise depuis /cart.js.
   ============================================================ */
(function () {
  'use strict';
  if (window.__lesCartCountSync) return;
  window.__lesCartCountSync = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var busy = false, again = false;

  function apply(n) {
    var els = document.querySelectorAll('cart-count');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent.trim() !== String(n)) els[i].textContent = n;
    }
    var dots = document.querySelectorAll('cart-dot');
    for (var j = 0; j < dots.length; j++) {
      if (n > 0) dots[j].classList.add('is-visible');
      else dots[j].classList.remove('is-visible');
    }
  }

  function refresh() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) apply(c.item_count); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(refresh, 150); }
      });
  }
  function schedule() { setTimeout(refresh, 120); }

  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      try { if (url && CART_MUTATION.test(url)) p.then(function () { schedule(); }, function () {}); } catch (e) {}
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var op = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__lesUrl = url; } catch (e) {}
      return op.apply(this, arguments);
    };
    var os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__lesUrl && CART_MUTATION.test(this.__lesUrl)) {
          this.addEventListener('loadend', function () { schedule(); });
        }
      } catch (e) {}
      return os.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
